export default __webpack_public_path__ + "static/media/pending.0826b519.svg";